import router from '@/router'
import store from '@/store'

// 白名单
const whiteList = ['/login', '/auto_login']

/**
 * 路由前置守卫（权限守卫）
 * @param {*} to 要到哪里去
 * @param {*} from 从哪里来
 * @param {*} next 是否要去？
 */
router.beforeEach(async (to, from, next) => {
    // 1. 用户已登录，则不允许进入 login
    // 2. 用户未登录，只允许进入 login
    // store.state.user.token
    if (to.query.token) {
        store.dispatch('user/saveToken', to.query.token)
    }
    if (store.getters.token) {
        // 1. 用户已登录，则不允许进入 login
        if (to.path === '/login') {
            next('/index')
        } else if (to.path === '/') {
            next('/workbench')
        } else {
            // 判断登录用户信息存不存在，若不存在，则获取用户信息
            if (!store.getters.hasUserInfo) {
                // 触发获取用户信息的 action，并获取用户当前权限
                // const data = await store.dispatch('user/getUserInfo')
                if (!store.getters.token) {
                    next('/login')
                } else {
                    const data = await store.dispatch('user/getUserInfo')
                    localStorage.setItem('userInfo', JSON.stringify(data))
                    // 所有子系统菜单
                    const allSysMenu = data.auths.menus
                    if (Object.keys(allSysMenu).length > 0) {
                        // 处理用户权限，筛选出需要添加的权限
                        if (!store.getters.subsystem) {
                            store.dispatch('permission/saveSubsystem', Object.keys(allSysMenu)[0])
                        }

                        const filterRoutes = await store.dispatch('permission/filterRoutes', allSysMenu)
                        // 利用 addRoute 循环添加
                        filterRoutes.forEach((item) => {
                            if (item.path[0] === '/') router.addRoute(item)
                        })
                        // 添加完动态路由之后，需要在进行一次主动跳转
                        return next({
                            path: to.path,
                            query: to.query,
                            params: to.params
                        })
                    }
                }
            }
            next()
        }
    } else {
        // 1. 用户未登录，只允许进入 login
        if (whiteList.indexOf(to.path) > -1) {
            next()
        } else {
            // 不在白名单
            next('/login')
        }
    }
})
